import '../styles/home-blog.css';
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { getFeaturedBlogPosts } from "../data/blogPosts";
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion';
import { slickDotPaging } from '../utils/slickAccessibleDots';

const FEATURED_LIMIT = 10;

const Homeblogslider = () => {
  const reduceMotion = usePrefersReducedMotion();
  const posts = getFeaturedBlogPosts(FEATURED_LIMIT);
  const loadState = posts.length ? "ready" : "empty";

  const sliderSettings = {
    arrows: false,
    slidesToShow: 3,
    dots: true,
    customPaging: slickDotPaging('Go to insight'),
    slidesToScroll: 1,
    infinite: posts.length > 2,
    className: "innerslide",
    autoplay: !reduceMotion,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    speed: 1000,
    margin: 30,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="home-blog-insights home-surface--light" aria-labelledby="home-blog-heading">
      <div className="container home-blog-insights__shell">
        <div className="recent-post-slider pt-6 pb-6">
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
              <div className="heading home-blog-insights__heading">
                <p className="home-focus-section__kicker">Delivery insights</p>
                <h2 id="home-blog-heading" className="heading-title">
                  Insights for Digital Delivery
                </h2>
                <p className="heading-text">
                  Practical notes on web development, ecommerce, integrations,
                  analytics, education platforms, and specialized delivery work.
                </p>
                <div className="heading-line">
                  <span className="short-line" />
                  <span className="long-line" />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 home-blog-insights__cta-wrap">
              <Link to="/blog" className="home-cta home-cta--primary">
                View all insights
              </Link>
            </div>
          </div>
          {loadState === "empty" ? (
            <p className="heading-text" role="status">
              No blog posts to show right now.{" "}
              <Link to="/blog">View blog</Link>
            </p>
          ) : null}
          {loadState === "ready" ? (
            <div className="theme-module news-slider-module home-blog-insights__slider">
              <Slider {...sliderSettings}>
                {posts.map((post) => (
                  <article key={post.id} className="hentry post home-blog-card">
                    <div className="home-blog-card__meta">
                      <span className="home-blog-card__category">
                        {post.category}
                      </span>
                      <time className="post__date published" dateTime={post.date}>
                        {post.date}
                      </time>
                    </div>
                    <div className="post__content home-blog-card__content">
                      <h3 className="post__title entry-title home-blog-card__title">
                        <Link to={`/blogs/${post.slug}`}>{post.title}</Link>
                      </h3>
                      <p className="post__text home-blog-card__excerpt">
                        {post.excerpt}
                      </p>
                    </div>
                    <div className="post__author author vcard home-blog-card__footer">
                      <span className="post__author-name fn">
                        <span className="post__author-link">
                          Plux Infosystems
                        </span>
                      </span>
                      <Link
                        to={`/blogs/${post.slug}`}
                        className="home-blog-card__read-more"
                      >
                        Read article
                      </Link>
                    </div>
                  </article>
                ))}
              </Slider>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default Homeblogslider;
